import { MobileBackIcon } from "@Icons/MainIcons";
import { Button } from "antd";
import { FC, Dispatch, SetStateAction, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import appConfig from "src/app.config";
import { useDirection } from "src/i18n/direction";
import PaymentSummary from "../PaymentSummary";
import { Payment } from "../../constants";

const PAYMOB_ELEMENT_ID = "paymob-payment-pixel";

const PaymobPayment: FC<{
  paymentData?: { provider: string; clientSecret: string };
  setIsPaymentStep: Dispatch<SetStateAction<boolean>>;
  selectedPayment?: Payment;
  currency: string;
}> = ({
  paymentData,
  setIsPaymentStep,
  selectedPayment,
  currency,
}) => {
  const pixelRef = useRef<Pixel | null>(null);
  const direction = useDirection();
  const { t } = useTranslation();

  const handleBack = () => {
    setIsPaymentStep(false);
  };

  useEffect(() => {
    if (!appConfig.paymobPublicKey || pixelRef.current || !paymentData || paymentData.provider !== "paymob") return;
    pixelRef.current = new Pixel({
      publicKey: appConfig.paymobPublicKey,
      clientSecret: paymentData.clientSecret,
      paymentMethods: ["card"],
      elementId: PAYMOB_ELEMENT_ID,
      afterPaymentComplete: () => {},

      customStyle: {
        Color_Input_Fields: "var(--color-background-default)",
        Direction: direction,
        Color_Primary: "var(--color-background-primary)",
        Color_Error: "var(--color-font-danger)",
        Vertical_Padding: "50",
        Vertical_Spacing_between_components: "30",
      },
    });
    return () => {
      pixelRef.current = null;
    };
  }, [paymentData]);

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="bg-background-default w-full rounded-md p-5 flex flex-col items-start gap-3">
        <Button
          onClick={handleBack}
          icon={<MobileBackIcon className="h-3 w-3" />}
          className="text-font-active! bg-transparent! shadow-none! border-none! p-0! m-0! font-semibold! text-lg!"
        >
          {t("Hotels.payment.paymentSelection")}
        </Button>
        {selectedPayment && <PaymentSummary selectedPayment={selectedPayment} currency={currency} />}
      </div>

      <div id={PAYMOB_ELEMENT_ID} className="w-full rounded-md bg-white px-5" />
    </div>
  );
};

export default PaymobPayment;
